










import Vue from 'vue';
import Lobby from './components/Lobby.vue';
import Game from './components/Game.vue';

export default Vue.extend({
  name: 'Home',
  components: {
    Lobby,
    Game,
  },
  props: ['gameid'],
  data() {
    return {
      playerNumber: -1,
      gameID: this.gameid,
    }
  }
});
